import * as Actions from '../../actions/app';

const initialState = {
  loading_inventory_products: false,
  inventory_products: null,
  total_pages_inventory_products: 1,
  total_registers_inventory_products: 0,

  loading_crud_inventory_product: false,
  crud_inventory_product: false,
};

const inventoryReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_INVENTORY_PRODUCTS: {
      return {
        ...state,
        loading_inventory_products: action.payload.loading,
        inventory_products:
          typeof action.payload.totalPaginas === 'undefined'
            ? state.inventory_products
            : action.payload.detalles,
        total_pages_inventory_products:
          typeof action.payload.totalPaginas === 'undefined'
            ? state.total_pages_inventory_products
            : action.payload.totalPaginas,
        total_registers_inventory_products:
          typeof action.payload.totalRegistros === 'undefined'
            ? state.total_registers_inventory_products
            : action.payload.totalRegistros,
      };
    }

    case Actions.CRUD_INVENTORY_PRODUCT: {
      return {
        ...state,
        loading_crud_inventory_product: action.payload.loading,
        crud_inventory_product: action.payload.crud,
      };
    }

    default: {
      return state;
    }
  }
};

export default inventoryReducer;
